import { render, staticRenderFns } from "./ContentConnector.vue?vue&type=template&id=4a3167f4&scoped=true&"
import script from "./ContentConnector.vue?vue&type=script&lang=js&"
export * from "./ContentConnector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3167f4",
  null
  
)

export default component.exports